import styled from '@emotion/styled'

import { MOBILE } from '../../../guided-toolbox/utils/breakpoints'

const BorderedCard = styled.div`
  border: ${p => p.theme.considerContainerBorder};
  border-radius: 8px;
  background-color: ${p => p.theme.considerContainerBgColor};
  margin: 20px 0;
  padding: 1rem;
`

const DrawerTitle = styled.div`
  color: ${p => p.theme.darkestGray};
  font-size: 1.5rem;
  font-weight: 600;
  padding-top: 24px;
  line-height: 1.3;
`

// Move the help icon before the Restore button on mobile.
const TopButtonGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 2rem;

  ${MOBILE} {
    flex-direction: row-reverse;
    justify-content: flex-start;
  }
`

// Limit the Restore button width on desktop and let it fill the row on mobile.
const RestoreButtonBox = styled.div`
  width: 290px;

  ${MOBILE} {
    flex: 1;
    width: auto;
  }
`

// Stack the actions full-width with Recalculate first on mobile.
const BottomButtonGroup = styled.div`
  display: flex;
  flex-wrap: wrap-reverse;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-top: 3.5rem;

  ${MOBILE} {
    flex-direction: column-reverse;
    flex-wrap: nowrap;
    align-items: stretch;
  }
`

const CardTitle = styled.div`
  color: ${p => p.theme.mediumGray};
  font-size: 1.25rem;
  font-weight: 600;
`

const RetAgeContainer = styled.div`
  display: flex;
  flex-wrap: wrap;

  & > div:first-of-type {
    margin-right: 36px;
  }
`

const InputLabel = styled.div`
  font-size: 0.875rem;
  color: ${p => p.theme.lightestGray};
`

const GoalField = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 13px 0;

  & > div:nth-of-type(1) {
    flex: 0 1 450px;

    & > div:nth-of-type(1) {
      color: #4a606a;
      font-size: 1.25rem;
      font-weight: 600;
      word-break: break-word;
    }

    & > div:nth-of-type(2) {
      color: ${p => p.theme.lightestGray};
      font-size: 0.875rem;
    }

    & > div:nth-of-type(3) {
      color: ${p => p.theme.lightestGray};
      font-size: 0.875rem;
      padding-top: 6px;
    }
  }

  & > div:nth-of-type(2) {
    flex: 1 1 450px;
    padding: 12px 0;
  }
`

const DollarSign = styled.span`
  font-size: 1.125rem;
  color: ${p => p.theme.lightestGray};
`

const DollarAmount = styled.span`
  color: ${p => p.theme.darkestGray};
  font-size: 1.125rem;
  font-weight: 600;
  padding-right: 6px;
`

const LoadingBox = styled.div`
  text-align: center;
  width: 100%;
`

const ContribLimitText = styled.p`
  color: ${p => p.theme.lightestGray};
  font-size: 14px;
  margin: 0 0 25px;
`

export {
  BorderedCard,
  DrawerTitle,
  TopButtonGroup,
  RestoreButtonBox,
  BottomButtonGroup,
  CardTitle,
  RetAgeContainer,
  InputLabel,
  GoalField,
  DollarSign,
  DollarAmount,
  LoadingBox,
  ContribLimitText,
}
